import {
  Button,
  Paper,
  Grid,
  TextField,
  Select,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Typography,
  Tab,
  Tabs,
  Chip,
  Tooltip
} from "@material-ui/core";
import * as React from "react";
import { observable, action, computed, toJS, autorun } from "mobx";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { config } from "src/config";

import { usersAdminStore } from "..";
import { observer } from "mobx-react";
import { companiesAdminStore } from "src/modules/admin/modules/CompaniesAdmin";
import { checkAuthStore, authStore } from "src/modules/auth/store";
import { Loading } from "src/components/loading";
import { history } from "src/history.js";
import { withRouter } from "react-router";
import { AdminToolBar } from "src/modules/admin/components";
import { validationsStore } from '../../../../validations';
import { permissionsStore } from '../../Permissions';

const styles = createStyles({
  root: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    // padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
  },
  rowContainer: {
    width: "100%",
    display: "flex",
    alignContent: "center",
    margin: "0 auto",
    // padding: "3rem",
  },
  columnContainer: {
    width: "100%",
    display: "flex",
    margin: "0 auto",
    // padding: "3rem",
  },
  textField: {
    display: "flex",
    paddingRight: "24px",
  },
  roleSelect: {
    minWidth: "9rem",
  },
  companySelect: {
    minWidth: "16.5rem",
  },
  appRoleSelect: {
    minWidth: "16.5rem",
    paddingTop: "1.5rem",
  },
  formContainer: {
    width: "100%",
    padding: "1.5rem",
  },
  submitContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
  },
  // submitButton: {
  //   backgroundColor: "#2A2A55",
  //   border: "1px solid #2D4D73",
  //   color: "#FAFAFA",
  // },
});

@observer
class UserForm extends React.Component<any> {

  public state = { current_tab: 0, siteSelectOpen: false, companySelectOpen: false }

  public render() {
    const { classes, mode } = this.props;
    // C-094.01
    const DataVal = this.props.currentUser.Phone.replace(/\D+/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3").slice(0, 14);

    // C-012
    let phoneStatus: boolean
    const regexParam = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
    phoneStatus = !regexParam.test(DataVal)
    if (
      !usersAdminStore.loaded ||
      !this.props.currentUser
    ) {
      return <Loading />;
    } else {

      return (
        <div>
          {/* C-012 */}
          <Grid container={true} direction="column">
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <TextField
                  label="First Name"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.FirstName}
                  InputLabelProps={{ shrink: true }}
                  error={this.props.currentUser.FirstName.length === 0 ? !validationsStore.validator["FirstName"].valid : false}
                  helperText={
                  this.props.currentUser.FirstName.length === 0 ?
                    !validationsStore.validator["FirstName"].valid
                      ? validationsStore.validator["FirstName"].errorMessage.join()
                      : " "
                    : false
                  }
                  required={true}
                  onChange={this.handleInput("FirstName")}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
              <Grid item={true} xs={6}>
                <TextField
                  label="Last Name"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.LastName}
                  InputLabelProps={{ shrink: true }}
                  error={this.props.currentUser.LastName.length === 0 ? !validationsStore.validator["LastName"].valid : false}
                  helperText={
                  this.props.currentUser.LastName.length === 0 ?
                    !validationsStore.validator["LastName"].valid
                      ? validationsStore.validator["LastName"].errorMessage.join()
                      : " "
                    : false
                  }
                  required={true}
                  onChange={this.handleInput("LastName")}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
            </Grid>
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <TextField
                  label="Email"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.Email}
                  InputLabelProps={{ shrink: true }}
                  error={this.props.toggleCancle === true ? false : !validationsStore.validator["Email"].valid}
                  helperText={
                  this.props.toggleCancle === true ? false
                    :
                    !validationsStore.validator["Email"].valid
                      ? validationsStore.validator["Email"].errorMessage.join()
                      : " "
                  }
                  required={true}
                  onChange={this.handleInput("Email")}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
              <Grid item={true} xs={6}>
              {/* C-094.12 C-094.01  */}
              <TextField
                  label="Phone Number"
                  classes={{ root: classes.textField }}
                  value={DataVal}
                  InputLabelProps={{ shrink: true }}
                  error={phoneStatus}
                  helperText={
                  phoneStatus
                      ? validationsStore.validator["Phone"].errorMessage.join()
                      : " "
                  }
                  required={true}
                  onChange={this.handleInput("Phone")}
                  disabled={this.props.match.params.view_type === 'detail'}
                // onBlur={this.formatPhoneNumber}
                />
              </Grid>
            </Grid>
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <TextField
                  label="Address"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.Address}
                  onChange={this.handleInput("Address")}
                  InputLabelProps={{ shrink: true }}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
              <Grid item={true} xs={6}>
                <TextField
                  label="City"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.City}
                  InputLabelProps={{ shrink: true }}
                  onChange={this.handleInput("City")}
                  disabled={this.props.match.params.view_type === 'detail'}
                // onBlur={this.formatPhoneNumber}
                />
              </Grid>
            </Grid>
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <TextField
                  label="State"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.State}
                  InputLabelProps={{ shrink: true }}
                  onChange={this.handleInput("State")}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
              <Grid item={true} xs={6}>
                <TextField
                  label="Zip"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.Zip}
                  InputLabelProps={{ shrink: true }}
                  onChange={this.handleInput("Zip")}
                  disabled={this.props.match.params.view_type === 'detail'}
                // onBlur={this.formatPhoneNumber}
                />
            <br />
              </Grid>
            </Grid>
            <Grid item={true} xs={6} />
          </Grid>
        </div>
      );
    }
  }

  @action
  protected handleInput = (property: string) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    this.setState({ siteSelectOpen: false, companySelectOpen: false, statusChecked: false })
    this.props.currentUser[property] = e.target.value;
    validationsStore.runValidator(property, this.props.currentUser[property] = e.target.value)
    this.props.sendDataToParent(false, false)
  }

}

export default withStyles(styles, { withTheme: true })(
  withRouter(UserForm)
);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/components/UsersForm.tsx